// Production DOM-shop → canvas handoff (IMPLEMENTATION §2.8). The ShopCard (M7 shell; the M0/M6 spike
// card until then) runs the pure card mini-FSM (shopCardFsm.ts: `touch-action: pan-x` row, 8 px axis
// lock, never preventDefault before it) and, on an upward drag-out, calls `adoptPointer`:
//   - the router's PointerController takes the pointer on the persistent #input root (setPointerCapture;
//     window listeners filtered by pointerId as the iOS fallback) and enters DRAG with the shop payload —
//     no `grab` (there is no item id yet);
//   - the router shows the DOM ghost (48 px above the finger), collapses an open sheet to its 28 px peek BY
//     TRANSFORM (the card stays mounted), lights the valid cells (query.resolveDrop / dropTargets);
//   - pointerup sends `drop {from: {k:'shop', item}}` → buyPlace / buyMerge (+ the 3 s ⟳ handle intent); a
//     reject snaps back to the peek and the sheet re-expands; pointercancel / lostpointercapture / blur /
//     a hidden page cancel silently and restore the sheet.
// Tap alternative (step 7): a tap on a card opens its detail pop-over (M7) whose Place button calls
// `beginTapPlace(item)`: valid cells glow and the next board tap buys there (the same resolver).
// Card slots (machine / Crate / Gallery cards, M7) adopt with a `slot` payload the same way (with a grab).
import type { Src } from '../sim/commands.ts';
import type { ShopId } from '../sim/gen/ids.ts';

export type AdoptPayload = Extract<Src, { k: 'shop' } | { k: 'slot' }>;

/** The input side a card talks to (the InputRouter). */
export interface AdoptTarget {
  adopt(e: PointerEvent, src: AdoptPayload): boolean;
  dragging(): boolean;
  beginTapPlace(item: ShopId): void;
}

let target: AdoptTarget | null = null;

export function setAdoptTarget(t: AdoptTarget | null): void {
  target = t;
}

/** Hands the card's pointer to #input; false = refused (another gesture runs, the cold open): the card
 * resets its own mini-FSM and does nothing. */
export function adoptPointer(e: PointerEvent, payload: AdoptPayload): boolean {
  return target ? target.adopt(e, payload) : false;
}

/** True while an adopted (or any board) drag runs: the shop row then preventDefaults touchmove so the
 * browser never starts a pan that would pointercancel the drag (M0 decision 3). */
export function adoptedDragActive(): boolean {
  return target ? target.dragging() : false;
}

/** §2.8 step 7: tap-placement from a card's Place button. */
export function beginTapPlace(item: ShopId): void {
  target?.beginTapPlace(item);
}
